const ScrollToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: "smooth",
    });
}

export default ScrollToTop;